// @ts-strict-ignore
import { Component, Input, Output, OnInit, EventEmitter, ViewChild  } from '@angular/core';
import { SohoSliderComponent } from 'ids-enterprise-ng';
import { LMFormatUtilService } from '@services/utils';

@Component ({
  selector: 'lm-cube-periodoverride-dialog',
  templateUrl: 'lm-cube-periodoverride-dialog.component.html'
})

export class LMCubePeriodOverrideDialogComponent implements OnInit {
  @Input() listSpec: LMListSpec;
  @Input() dataViewSet: LMDataViewSet;
  @Input() listState: LMListState;

  // The following two inputs are from BusinessClassTotal, that defines the cube cell relation.
  // The list spec, state or dataviewset is not available in this case.
  @Input() cubeInterval: string;
  @Input() cubeCurrentPeriod: string;

  @ViewChild(SohoSliderComponent) sliderPeriod: SohoSliderComponent;

  public cubeViewer: boolean;
  public interval: string;
  public currPeriodKey: string;
  public date: string;
  public year: string;
  private week: string;
  private month: string;

  public labelPeriodOverride: string;
  public labelPeriod: string;
  public labelYear: string;
  private labelMonth: string;
  private labelWeek: string;

  public sliderPeriodValue: string;
  public sliderPeriodLabel: string;
  public sliderMin: number;
  public sliderMax: number;

  public dateFormat: string;
  private updateState: boolean;

  public disableOptions: SohoDatePickerDisable = {
    dates:     '',
    minDate:   this.lmFormatUtilService.minDate,
    maxDate:   this.lmFormatUtilService.maxDate,
    dayOfWeek: []
  };

  public pickerOptions: SohoDatePickerOptions;
  public yearAttributes = [ { name: 'data-automation-id', value: 'lm-period-override-year' } ];
  public yearOptions = JSON.stringify({ attributes: this.yearAttributes });
  public periodAttributes = [ { name: 'data-automation-id', value: 'lm-period-override-week-month' }];

  constructor( private lmFormatUtilService: LMFormatUtilService) {}

  ngOnInit() {
    this.initialize();
    this.pickerOptions = {
      dateFormat: this.dateFormat,
      disable: this.disableOptions
    };
  }

  private initialize(): void {
    this.cubeViewer = (this.dataViewSet !== undefined);
    if (this.cubeViewer) {
      this.interval = this.dataViewSet.cubeInfo.periodInterval;
      this.currPeriodKey = this.dataViewSet.cubeInfo.periodDimension;

      if (this.interval === 'DAILY') {
        this.date = this.currPeriodKey;
        this.dateFormat = Soho.Locale.calendar().dateFormat.short;
      } else {
        const periodParts = this.currPeriodKey.split('/');
        this.year = periodParts[1];
        (this.interval === 'WEEKLY') ? this.week = periodParts[0] : this.month = periodParts[0];
      }
    } else if (this.cubeCurrentPeriod && this.cubeInterval) {
      this.interval = this.cubeInterval;
      this.currPeriodKey = this.cubeCurrentPeriod.replace('\n', '/');

      const periodParts = this.currPeriodKey.split('/');
      if (this.interval === 'DAILY') {
        const periodKeyToDate = new Date(parseInt(periodParts[0], 10), 0);
        periodKeyToDate.setDate(parseInt(periodParts[1], 10));
        this.dateFormat = Soho.Locale.calendar().dateFormat.short;
        const formatDateAttribs: any = {
          pattern:       this.dateFormat,
          fromGregorian: (Soho.Locale.calendar().name === 'islamic-umalqura') ? true : false
        };
        this.date = Soho.Locale.formatDate(periodKeyToDate, formatDateAttribs);
      } else {
        this.year = periodParts[0];
        (this.interval === 'WEEKLY') ? this.week = periodParts[1] : this.month = periodParts[1];
      }
    }

    this.labelPeriodOverride = Soho.Locale.translate('PeriodOverride');
    this.labelPeriod = (this.dataViewSet?.cubeInfo?.variablePeriod) ? Soho.Locale.translate('VariablePeriod') : Soho.Locale.translate('CurrentPeriod');
    this.labelYear = Soho.Locale.translate('Year');
    this.labelMonth = Soho.Locale.translate('Month');
    this.labelWeek = Soho.Locale.translate('Week');

    this.sliderMin = 1;
    if (this.interval === 'WEEKLY') {
      this.sliderPeriodLabel = this.labelWeek;
      this.sliderPeriodValue = this.week;
      this.sliderMax = 53;
    } else {
      this.sliderPeriodLabel = this.labelMonth;
      this.sliderPeriodValue = this.month;
      this.sliderMax = 12;
    }
  }

  public onDirty(event: any) {
    this.updateState = true;
  }

  public onPristine(event: any) {
    // Checkbox unchecked calls onPristine. The value is changed from the initial state, so set updateState to true.
    this.updateState = true;
  }

  public onSliderPeriodUpdated(event: any) {
    // this.currPeriodKey = this.sliderPeriod.value + '/' + this.year;
    this.updateState = true;
  }

  public onReset(): boolean {
    if (Object.keys(this.listState).length > 0 && this.listState.hasOwnProperty('cubeOverrides')) {
      this.listState.cubeOverrides.periodOverrides = {};
      return true;
    }
    return false;
  }

  public onApply(): boolean {
    if (this.updateState && this.cubeViewer) {
      this.listState.cubeOverrides = this.listState.cubeOverrides || {};
      this.listState.cubeOverrides.periodOverrides = this.getCubeOverrides();
    }
    return this.updateState;
  }

  private getCubeOverrides(): LMCubePeriodOverrides {
    const cubePeriodOverrides: LMCubePeriodOverrides = {};
    if (this.interval === 'DAILY') {
      this.currPeriodKey = this.date;
    } else {
      this.currPeriodKey = this.sliderPeriod.value[0] + '/' + this.year;
    }
    cubePeriodOverrides.periodOverride = this.currPeriodKey;
    cubePeriodOverrides.overridePeriods = true;
    if (this.dataViewSet.cubeInfo.variablePeriod) {
      cubePeriodOverrides.periodKey = this.dataViewSet.cubeInfo.periodKey;
    }
    return cubePeriodOverrides;
  }

  public getCubeCellRelPeriodKey(): string {
    if (this.cubeInterval === 'DAILY') {
      const periodDate: Date = Soho.Locale.parseDate(this.date, this.dateFormat, false);
      return periodDate.getFullYear() + '/Day/' + this.getDayOfTheYear();
    } else {
      const periodType = (this.cubeInterval === 'MONTHLY') ? '/Month/' : '/Week/';
      return this.year + periodType + this.sliderPeriod.value[0];
    }
  }

  private getDayOfTheYear(): string {
    const periodDate = Soho.Locale.parseDate(this.date, this.dateFormat, false);
    const startDate = new Date(Date.UTC(periodDate.getFullYear(), 0, 0)); // Dec 31 of the previous year
    const msInDay = 1000 * 60 * 60 * 24;
    return ((+(periodDate) - +(startDate)) / msInDay).toFixed();
  }
}
